<template>
  <div class="service">
    <div class="service-box">
      <div class="service-content">
        <div class="service-content-left">
          <div class="service-content-one">倾斜摄影 \ 成果提供\系统展示</div>
          <div class="service-content-two">无人机航拍</div>
          <div class="service-content-four" style=" margin-top: 30px;">无人机航拍服务结合倾斜摄影+三维建模技术、二维数据、GIS</div>
          <div class="service-content-four">数据把三维模型成果应用在项目中，精准直观展示、测量拆迁区</div>
          <div class="service-content-four">域的准确范围、提高征收的效率、数据准确性、可视化效果，实</div>
          <div class="service-content-four">现图上征收。</div>
        </div>
        <div class="service-content-right">
          <img src="../assets/img/hangpai_0111.png" />
        </div>
      </div>
    </div>
    <div class="service-content-box">
      <div class="service-one">
        <div class="service-one-left" id="wrapper-text">
          <div class="service-text-one">倾斜摄影外业航飞</div>
          <div class="service-text-two">The devices offer aerial footage</div>
          <div class="service-text-three" style="margin-top:30px">前期进行区域摸底、场地勘察、航线设计、航线</div>
          <div class="service-text-three">规划后，进行外业航飞。</div>
        </div>
        <div class="service-one-right" id="wrapper-img">
          <img src="../assets/img/hangpai_02.png" />
        </div>
      </div>
      <div class="service-two">
        <div class="service-one-left" id="wrapper-text1">
          <div class="service-text-one">航拍成果提供</div>
          <div class="service-text-two">The aerial data</div>
          <div class="service-text-three" style="margin-top:30px">可提供实景三维模型数据、二维矢量数据、建筑</div>
          <div class="service-text-three">面积清册、正射影像图。</div>
        </div>
        <div class="service-one-right" id="wrapper-img1">
          <img src="../assets/img/hangpai_03.png" />
        </div>
      </div>
      <div class="service-three">
        <div class="service-one-left" id="wrapper-text2">
          <div class="service-text-one">系统展示航拍地图</div>
          <div class="service-text-two">the show of the system Based on GIS</div>
          <div class="service-text-three" style="margin-top:30px">航拍成果关联至所购买的征拆系统相对应的项</div>
          <div class="service-text-three">目，被征收户档案同时与GIS二维及三维挂接，</div>
          <div class="service-text-three">图上可看被征收户数据。</div>
        </div>
        <div class="service-one-right" id="wrapper-img2">
          <img src="../assets/img/hangpai_04.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight service-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft service-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight service-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft service-one-left'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight service-one-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft service-one-left'
    );
  }
};
</script>
<style>
.service {
  width: 100%;
}
.service-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.service-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.service-content-left {
  margin-top: 70px;
  /* margin-left: 30px; */
  width: 50%;
}
.service-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.service-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.service-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.service-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.service-content-right {
  width: 50%;
}
.service-content-right img {
  width: 100%;
}
.service-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.service-one,
.service-two,
.service-three {
  display: flex;
  height: 500px;
  padding: 0px 80px;
  overflow: hidden;
}
.service-three {
  padding-bottom: 30px;
}
.service-text-one {
  margin-top: 150px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.service-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.service-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.service-one-left {
  padding-right: 40px;
  width: 50%;
}
.service-one-right {
  width: 50%;
}
.service-one-right img {
  margin-top: 50px;
  width: 100%;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .service-content,
  .service-content-box {
    width: 1200px !important;
  }
  .service-one-left {
    padding-right: 30px!important;
  }
  .service-content-two {
    font-size: 48px !important;
  }
  .service-text-one {
    font-size: 36px !important;
  }
  .service-text-two {
    font-size: 28px !important;
  }
  .service-text-three {
    font-size: 24px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/service.vue